import { useFlags } from 'launchdarkly-react-client-sdk';
import { useIsSmallViewportWidth } from 'hooks/use-is-small-viewport-width.hook';
import { useSearchParams } from 'hooks/use-search-params.hook';
import { useMemo } from 'react';

export const useBackButtonVisibility = (): boolean => {
  const isMobileDevice = useIsSmallViewportWidth();
  const { showResourceBookingNavigation: isResourceBookingNavigationVisible } = useFlags();
  const { hideBackButton } = useSearchParams<{ hideBackButton?: string }>();

  return useMemo<boolean>(() => {
    if (hideBackButton === 'true') {
      return false;
    }

    return isResourceBookingNavigationVisible || !isMobileDevice;
  }, [isMobileDevice, isResourceBookingNavigationVisible, hideBackButton]);
};
